import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {jobStatuses} from '../constants-enumerate';

const DEFAULT_CLASS_MAP = {
  'badge-primary': false,
  'badge-secondary': false,
  'badge-success': false,
  'badge-danger': false,
  'badge-warning': false,
  'badge-info': false,
  'badge-light': false,
  'badge-dark': false
};

/**
 * @summary JobStatusBadge
 * @extends {AoflElement}
 */
@customElement('job-status-badge')
class JobStatusBadge extends AoflElement {
  /**
   * Creates an instance of JobStatusBadge.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'job-status-badge';

  @property({type: String, attribute: false})
  status = '';

  @property({type: Object, attribute: false})
  classes = Object.assign({}, DEFAULT_CLASS_MAP);

  update(properties) {
    if (properties.has('status')) {
      if (this.status === jobStatuses.FAILED) {
        this.classes = Object.assign({}, DEFAULT_CLASS_MAP, {
          'badge-danger': true
        });
      } else if (this.status === jobStatuses.CANCELED) {
        this.classes = Object.assign({}, DEFAULT_CLASS_MAP, {
          'badge-dark': true
        });
      } else if (this.status === jobStatuses.DONE) {
        this.classes = Object.assign({}, DEFAULT_CLASS_MAP, {
          'badge-success': true
        });
      } else {
        this.classes = Object.assign({}, DEFAULT_CLASS_MAP, {
          'badge-primary': true
        });
      }
    }
    super.update(properties);
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default JobStatusBadge;
